import React from "react";

const About = () => {
  return (
    <div className="container mx-auto py-10">
      <h2 className="text-3xl font-bold text-center mb-6">About Us</h2>
      <p className="text-lg text-gray-700 text-center max-w-2xl mx-auto">
        Quickfit is dedicated to revolutionizing your shopping experience with personalized fashion insights and recommendations. Stay tuned as we prepare to launch something exciting – coming soon!
      </p>
    </div>
  );
};

export default About;
